export default "__VITE_ASSET__Bg0334f___"